export const adminPath = () => "/admin";
export const adminBranchesPath = () => "/admin/branches";
export const adminCustomersPath = () => "/admin/customers";
export const adminPhoneNosPath = () => "/admin/phone-nos";
export const adminPlansPath = () => "/admin/plans";
export const adminPlanPath = (plan) => `/admin/plans/${plan.id}`;
export const adminNewPlanPath = () => "/admin/plans/new";
export const adminEditPlanPath = (plan) => `/admin/plans/${plan.id}/edit`;
export const adminPricesPath = () => "/admin/prices";
export const adminAccessApiKeysPath = () => "/admin/access-api-keys";
export const adminSecretsPath = () => "/admin/secrets";
export const adminPricePath = (price) => `/admin/prices/${price.id}`;
export const adminNewPricePath = () => "/admin/prices/new";
export const adminEditPricePath = (price) => `/admin/prices/${price.id}/edit`;
